import { Component, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../services/API/api.service';
import { AlertService } from '../../services/Alert/alert.service';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {
  @ViewChildren('otp1,otp2,otp3,otp4,otp5,otp6') otpInputs!: QueryList<ElementRef>;

  currentStep: number = 1;
  isLoading: boolean = false;
  isResending: boolean = false;
  resetForm: FormGroup;
  otpCodeForm: FormGroup;
  updatePasswordForm: FormGroup;

  constructor(
    private apiService: ApiService,
    private alertService: AlertService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.resetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.otpCodeForm = this.fb.group({
      otp_code: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
    });

    this.updatePasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      password_confirmation: ['', [Validators.required]]
    }, { validator: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    // Check if user is already logged in
    const token = localStorage.getItem('romaPizza_token');
    if(token) {
      this.router.navigate(['/']);
    }
  }

  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('password_confirmation')?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }

  resetPassword() {
    this.resetForm.markAllAsTouched();
    if(this.resetForm.valid) {
      this.isLoading = true;
      this.apiService.resetPassword(this.resetForm.value).subscribe({
        next: response => {
          if(response.success) {
            this.currentStep = 2;
            this.alertService.success(response.message);
          }
          this.isLoading = false;
        }, 
        error: (error: any) => {
          this.alertService.danger(error.error.message);
          this.isLoading = false;
        }
      });
    }
  }

  moveToNext(event: any, index: number) {
    const input = event.target;
    const value = input.value;
    
    // Update the hidden OTP field
    const otpArray = this.otpCodeForm.value.otp_code.split('');
    otpArray[index - 1] = value;
    this.otpCodeForm.patchValue({ otp_code: otpArray.join('') });
    
    // Move to next input
    if(value.length === 1 && index < 6) {
      this.otpInputs.toArray()[index].nativeElement.focus();
    }
  }

  verifyOtp() {
    this.otpCodeForm.markAllAsTouched();
    if(this.otpCodeForm.valid) {
      this.isLoading = true;
      this.apiService.verifyOtp({
        email: this.resetForm.value.email,
        otp_code: this.otpCodeForm.value.otp_code
      }).subscribe({
        next: response => {
          if(response.success) {
            this.currentStep = 3;
            this.alertService.success(response.message);
          }
          this.isLoading = false;
        }, 
        error: (error: any) => {
          this.alertService.danger(error.error.message);
          this.isLoading = false;
        }
      });
    }
  }

  resendOtp() {
    this.isResending = true;
    this.apiService.resentOtp(this.resetForm.value).subscribe({
      next: response => {
        if(response.success) {
          this.alertService.success(response.message);
        }
        this.isResending = false;
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.isResending = false;
      }
    });
  }

  updatePassword() {
    this.updatePasswordForm.markAllAsTouched();
    if(this.updatePasswordForm.valid) {
      this.isLoading = true;
      const payload = {
        email: this.resetForm.value.email,
        otp_code: this.otpCodeForm.value.otp_code,
        password: this.updatePasswordForm.value.password,
        password_confirmation: this.updatePasswordForm.value.password_confirmation
      };
      
      this.apiService.updatePassword(payload).subscribe({
        next: response => {
          if(response.success) {
            this.currentStep = 4;
            this.alertService.success(response.message);
            setTimeout(() => {
              // this.router.navigate(['/']);
              const formData = new FormData()
              formData.append('password', payload.password);
              formData.append('email', payload.email);
              this.apiService.signIn(formData).subscribe((response: any) => {
                const isVerified = response.data.user.is_verified
                if(isVerified == 1){
                  localStorage.setItem('romaPizza_token', response.data.token);
                  localStorage.setItem('romaPizza_userData', JSON.stringify(response.data.user));
                  const token = localStorage.getItem('romaPizza_token')?.toString();
                  const data = jwtDecode(token);
                  const exp = data['exp'];
                  localStorage.setItem('romaPizza_expDate', JSON.stringify(exp));
                  this.alertService.success('Logged in successfully');
                  sessionStorage.removeItem('guestMode'); 
                  sessionStorage.removeItem('cartItems');
                  sessionStorage.removeItem('favoriteItems');
                  sessionStorage.removeItem('romaPizza_token_to_verify');
                  localStorage.removeItem('romaPizza_token_to_verify');
                  setTimeout(() => {
                    window.location.href = '/';
                  }, 2000);
                }
              }, (error: any) => {
                this.alertService.danger(error.error.message);
                this.isLoading = false;
              });
            }, 2000);
          }
          this.isLoading = false;
        }, 
        error: (error: any) => {
          this.alertService.danger(error.error.message);
          this.isLoading = false;
        }
      });
    }
  }
}